import React from 'react'
import { Col, Row } from 'react-flexbox-grid'

export const ExpiradoPowerpay = ({ mostrarPpVencido }) => {
  return (
    <>
    {
      mostrarPpVencido &&
      <Row center="xs">
        <Col xs={12} sm={5}>
          <h4>
            Ya existe una transacción expirada
          </h4>
        </Col>
      </Row>
    }
    </>
  )
}
